// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { signInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { FormFieldClickable } from "@insite/mobius/FormField";
import { css } from "styled-components";

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 15px;
        `,
    },
};
signInExistingAccountStyles.form = {
    css: css`
        max-width: 450px;
    `,
};

signInExistingAccountStyles.resetPasswordModal = {
    sizeVariant: "small",
};

signInExistingAccountStyles.signInGridContainer = {
    gap: 16,
};

signInExistingAccountStyles.icon = {
    css: css`
        padding-top: 0;
    `,
};

signInExistingAccountStyles.passwordTextField = {
    cssOverrides: {
        formInputWrapper: css`
            ${FormFieldClickable} {
                &:not(:disabled):hover {
                    & > span {
                        color: ${color("common.ui9")};
                    }
                }
            }
        `,
    },
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h3",
    as: "h3",
    css: css`
        margin-bottom: 12px;
    `,
};

signInExistingAccountStyles.signInButton = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: auto;
        }
    `,
};
